<div class="row">
    <div class="notifications-container">
        <fh-notify-notification *ngFor="let notification of notifications" [notification]="notification" (dismissNotify)="onDismissNotify($event)"></fh-notify-notification>
    </div>
</div>